/**
 * yoda
 */
import { getAppEnv } from '../base/env'
import LibLoader from '../base/lib-loader'
import { APP_ENV } from '../consts'
import { lxMV } from '../lx'
import { reportWarn } from '../owl'

let lib: LibLoader
let flag = false

window.succCallbackFun = function () {
  lxMV('b_airbnb_4hwcf9nl_mv')
  window.$toasted.show('验证成功，即将刷新页面', {
    duration: 1500,
  })
  setTimeout(() => {
    window.location.reload()
  }, 2000)
}

window.failCallbackFun = function (data: {}) {
  flag = false
  lxMV('b_airbnb_irl1bevn_mv')
  reportWarn({
    name: 'yoda 验证失败',
    global: true,
    msg: data,
  })
}

function makeDom() {
  const yodaEl = document.createElement('div')
  yodaEl.setAttribute('class', 'yoda-wrapper')
  const yodaMask = document.createElement('div')
  yodaMask.setAttribute('class', 'yoda-mask')
  const yodaContainer = document.createElement('div')
  yodaContainer.setAttribute('id', 'yoda')
  yodaEl.appendChild(yodaMask)
  yodaEl.appendChild(yodaContainer)
  document.body.appendChild(yodaEl)
}

// https://km.sankuai.com/page/108012732
// https://km.sankuai.com/page/28330607
// https://km.sankuai.com/page/37428928
export default function (requestCode: string) {
  return new Promise((resolve: Function) => {
    if (!lib) {
      lib = new LibLoader('lib-yoda', 'https://s0.meituan.net/mxx/yoda/yoda.seed.js')
    }
    if (flag) {
      resolve()
      return
    }
    flag = true
    makeDom()
    lib.push(() => {
      lxMV('b_airbnb_y22aj16x_mv')
      const options = {
        requestCode, // 必须 授权码
        succCallbackFun: 'succCallbackFun', // 必须 成功回调函数名 字符串格式
        failCallbackFun: 'failCallbackFun', // 必须 失败回调函数名 字符串格式
        root: 'yoda', // 必须 挂载业务方页面节点id
        theme: 'meituan', // 主题
        mounted: () => {
          console.warn('[yoda] loaded')
        }, // 可选 模块加载完成回调函数
        // isMobile: true  // 可选 true或1指定i版(H5)，false或0指定PC版。不指定则根据当前浏览器UA判断。
        // style: {}       // 可选 样式自定义 可参考 i版：https://km.sankuai.com/page/28330695  pc:https://km.sankuai.com/page/28330699
        // yodaLanguage: 'zh-CN' // 可选 i版短信、滑块、图片支持中日英 中文:zh-CN \ 日文:ja \ 英文: en
      }
      if (window.YodaSeed) {
        if (getAppEnv() !== APP_ENV.production) {
          window.YodaSeed(options, getAppEnv()) // 线下 dev|test|ppe|staging
        } else {
          window.YodaSeed(options) // 线上调用
        }
      } else {
        //
      }
      resolve()
    })
  })
}
